import { Collapse, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { getOriginalImage } from "../../../utils/setting";
import ImageGallery from "../../imageGallery";
import ImageLibrary from "../../imageLibrary";
import Loading from "../../loading";
import AdditionalInfo from "./additionalInfo";
import Attribute from "./attribute";
import Description from "./description";
import Inventory from "./inventory";
import SessionLabel from "./sessionLabel";
import { style } from "./styles";
import Variant from "./variant";

export class ProductMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data:
        this.props.data && this.props.data.id
          ? this.props.data
          : {
              date_created: null,
              date_updated: null,
              images: [],
              dimensions: {
                length: 0,
                width: 0,
                height: 0,
              },
              name: "",
              description: "",
              meta_description: "",
              meta_title: "",
              tags: [],
              attributes: [
                // {
                //     name : "Brand",
                //     value : "Brand A"
                // },
                // {
                //     name : "Size",
                //     value : "M"
                // }
              ],
              enabled: true,
              discontinued: false,
              slug: "",
              sku: "",
              code: "",
              tax_class: "",
              related_product_ids: [],
              prices: [],
              cost_price: 0,
              regular_price: 0,
              sale_price: 0,
              quantity_inc: 1,
              quantity_min: 1,
              weight: 0,
              stock_quantity: 1,
              position: null,
              date_stock_expected: null,
              date_sale_from: null,
              date_sale_to: null,
              stock_tracking: false,
              stock_preorder: false,
              stock_backorder: false,
              category_id: "",
              category_ids: [],
              variants: [],
            },
      openCollapse: {
        description: true,
        inventory: true,
        variants: true,
        attribute: true,
        additionalInfo: true,
        image: true,
      },
    };
  }
  async componentDidMount() {
    this.props.onRef(this);
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.data && nextProps.data.id !== this.state.data.id)
      this.setState({
        data: nextProps.data,
      });
  };
  handleClick = (name) => () => {
    let { openCollapse } = this.state;
    openCollapse[name] = !openCollapse[name];
    this.setState(openCollapse);
  };
  handleChangeProduct = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let product = this.state.data;
    product[name] = value;
    this.setState({
      product,
    });
  };
  handleSubComponentChange = (name, value) => {
    let state = this.state;
    state[name] = value;
    this.setState({
      state,
    });
  };
  getData = () => {
    return this.state.data;
  };
  getImageLibrary = () => {
    return this.ImageLibrary.getImageLibrary();
  };
  handleSelectImage = async (data) => {
    this.props.handleSelectImage(data);
  };
  deleteImage = async (data) => {
    this.props.deleteImage(data);
  };
  updateImageGallery = async (imageGallery) => {
    imageGallery = imageGallery.map((e) => getOriginalImage(e));
    this.loading.startLoading();
    let data = {
      serviceCode: this.state.data.serviceCode,
      code: this.state.data.code,
      imageGallery: JSON.stringify(imageGallery),
    };
  };
  render() {
    const { t, classes } = this.props;
    let { openCollapse } = this.state;
    return (
      <>
        {/* <Divider className={classes.divider}/> */}
        <Loading onRef={(id) => (this.loading = id)} />
        {/* Description */}
        <div
          className={classes.sessionContainer}
          onClick={this.handleClick("description")}
        >
          <SessionLabel label={t("product_description")} />{" "}
          {openCollapse.description ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={openCollapse.description}>
          <Description product={this.state.data} />
        </Collapse>
        {/* Inventory */}
        <div
          className={classes.sessionContainer}
          onClick={this.handleClick("inventory")}
        >
          <SessionLabel label={t("product_inventory")} />{" "}
          {openCollapse.inventory ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={openCollapse.inventory}>
          <Inventory product={this.state.data} />
        </Collapse>

        {/* Variants */}
        <div
          className={classes.sessionContainer}
          onClick={this.handleClick("variants")}
        >
          <SessionLabel label={t("product_variants")} />{" "}
          {openCollapse.variants ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={openCollapse.variants}>
          <Variant product={this.state.data} />
        </Collapse>

        {/* Attributes */}
        <div
          className={classes.sessionContainer}
          onClick={this.handleClick("attribute")}
        >
          <SessionLabel label={t("product_attribute")} />{" "}
          {openCollapse.attribute ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={openCollapse.attribute}>
          <Attribute product={this.state.data} />
        </Collapse>

        {/* Additional Info */}
        <div
          className={classes.sessionContainer}
          onClick={this.handleClick("additionalInfo")}
        >
          <SessionLabel label={t("product_additional_info")} />{" "}
          {openCollapse.additionalInfo ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={openCollapse.additionalInfo}>
          <AdditionalInfo product={this.state.data} />
        </Collapse>

        <div
          className={classes.sessionContainer}
          onClick={this.handleClick("image")}
        >
          <SessionLabel label={t("product_image")} />{" "}
          {openCollapse.image ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={openCollapse.image}>
          <Paper className={classes.container}>
            {this.props.type === "create" ? (
              <ImageLibrary onRef={(id) => (this.ImageLibrary = id)} />
            ) : (
              <ImageGallery
                imageGallery={this.state.data.images}
                handleSelectImage={this.handleSelectImage}
                deleteImage={this.deleteImage}
                updateImageGallery={this.updateImageGallery}
              />
            )}
            {/* <InputFileReader onRef = {id => this.InputFileReader = id} defaultImg={this.state.data.image} style = {classes} container = 'square' selectStorageMode={true} /> */}
          </Paper>
        </Collapse>
      </>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  insertProduct: dispatch.product.insertProduct,
  updateProduct: dispatch.product.update,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(style, { withTheme: 0 })(ProductMenu)));
